/* POWMIX theme behaviour: no dependencies. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || (window.PM && window.PM.moneyFormat) || '{{amount_with_comma_separator}}€';
    function delimit(n, precision, thousands, decimal) {
      if (isNaN(n) || n === null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount': value = delimit(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ','); break;
      default: value = delimit(cents, 2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function once(el, key) { if (el['__pm_' + key]) return false; el['__pm_' + key] = true; return true; }
  function boot() {
  /* ---- carousels ---- */
  $$('[data-rail]').forEach(function (wrap) {
    if (!once(wrap, 'rail')) return;
    var rail = $('.pm-rail', wrap);
    if (!rail) return;
    var prev = $('[data-rail-prev]', wrap), next = $('[data-rail-next]', wrap), bar = $('.pm-railnav__bar i', wrap);
    function step() {
      var card = rail.children[1] || rail.children[0];
      return card ? card.getBoundingClientRect().width + 16 : 320;
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      var p = max > 0 ? rail.scrollLeft / max : 0;
      if (bar) {
        var track = bar.parentNode.clientWidth;
        var w = Math.max(60, Math.round(track * rail.clientWidth / rail.scrollWidth));
        bar.style.width = w + 'px';
        bar.style.left = Math.round((track - w) * p) + 'px';
      }
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---- hero slider ---- */
  $$('[data-hero]').forEach(function (hero) {
    if (!once(hero, 'hero')) return;
    var slides = $$('.pm-hero__slide', hero), dots = $$('[data-hero-dot]', hero);
    if (slides.length < 2) return;
    var i = 0, timer = null, delay = parseInt(hero.getAttribute('data-autoplay') || '0', 10) * 1000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    var paused = reduce, pauseBtn = $('[data-hero-pause]', hero);
    function start() { if (delay && !paused && !document.hidden) { stop(); timer = setInterval(function () { go(i + 1); }, delay); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function setPaused(on) {
      paused = on;
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', pauseBtn.getAttribute(on ? 'data-label-play' : 'data-label-pause'));
      }
      if (on) stop(); else start();
    }
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!paused); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    var p = $('[data-hero-prev]', hero), n = $('[data-hero-next]', hero);
    if (p) p.addEventListener('click', function () { go(i - 1); start(); });
    if (n) n.addEventListener('click', function () { go(i + 1); start(); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop); hero.addEventListener('focusout', start);
    go(0); setPaused(paused);
  });

  /* ---- product: variant picker ---- */
  $$('[data-product]').forEach(function (root) {
    if (!once(root, 'product')) return;
    var json = $('[data-product-json]', root);
    if (!json) return;
    var data;
    try { data = JSON.parse(json.textContent); } catch (e) { return; }
    var variants = data.variants || [], qtyIndex = data.qtyIndex, labels = data.labels || {};
    var idInput = $('[name="id"]', root), buy = $('[data-buy]', root), lastId = idInput ? String(idInput.value) : '';
    var sticky = $('[data-sticky]');
    var reduceMotionPick = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* suscripción (selling plans): sin data.sub todo funciona como compra única */
    var sub = data.sub || null, subBox = sub ? $('[data-sub]', root) : null;
    function subPlanId() {
      if (!subBox) return null;
      var sel = $('[data-sub-plan]', subBox), r = $('[data-sub-radio="sub"]', subBox);
      return sel ? sel.value : (r ? r.value : null);
    }
    function subOn() { var r = subBox && $('[data-sub-radio="sub"]', subBox); return !!(r && r.checked && !r.disabled); }
    function alloc(v, id) {
      if (!v || !v.plans || !id) return null;
      return v.plans.filter(function (a) { return String(a.id) === String(id); })[0] || null;
    }
    function subPct(v, id) {
      var p = sub && sub.plans.filter(function (x) { return String(x.id) === String(id); })[0], a = alloc(v, id);
      if (p && p.pct != null) return p.pct;
      return a && v.price > a.price ? Math.round((v.price - a.price) * 100 / v.price) : 0;
    }
    /* precio que paga el cliente con la forma de compra elegida */
    function eff(v) {
      var a = subOn() ? alloc(v, subPlanId()) : null;
      if (!a) return { price: v.price, compare: v.compare_at_price };
      return { price: a.price, compare: Math.max(v.compare_at_price || 0, v.price) };
    }
    function subSync(v) {
      if (!subBox) return;
      var pid = subPlanId(), a = alloc(v, pid), r = $('[data-sub-radio="sub"]', subBox), once = $('[data-sub-radio="once"]', subBox);
      if (r) {
        r.value = pid || '';
        r.disabled = !a;
        if (!a && r.checked && once) once.checked = true;
      }
      $$('[data-sub-opt]', subBox).forEach(function (o) {
        var inp = $('input[type="radio"]', o);
        o.classList.toggle('is-on', !!(inp && inp.checked));
        o.classList.toggle('is-off', !!(inp && inp.disabled));
      });
      var g = gels(v), short = labels.perGelShort || '/gel';
      text('[data-sub-once-price]', formatMoney(v.price), subBox);
      text('[data-sub-once-unit]', formatMoney(Math.round(v.price / g)) + short, subBox);
      show('[data-sub-once-unit]', g > 1, subBox);
      text('[data-sub-price]', a ? formatMoney(a.price) : '', subBox);
      text('[data-sub-compare]', formatMoney(v.price), subBox);
      show('[data-sub-compare]', !!(a && v.price > a.price), subBox);
      text('[data-sub-unit]', a ? formatMoney(Math.round(a.price / g)) + short : '', subBox);
      show('[data-sub-unit]', !!a && g > 1, subBox);
      var pct = subPct(v, pid);
      var maxPct = (sub.plans || []).reduce(function (m, p) { return Math.max(m, p.pct || 0); }, pct);
      text('[data-sub-title]', maxPct > 0 ? (sub.title || '').replace('[pct]', maxPct) : (sub.titlePlain || ''), subBox);
    }

    function selected() {
      return $$('[data-option-index]', root).map(function (g) {
        var on = $('[aria-pressed="true"]', g);
        return on ? on.getAttribute('data-value') : null;
      });
    }
    function find(opts) {
      if (!opts.length) return variants[0];
      return variants.filter(function (v) { return v.options.every(function (o, k) { return o === opts[k]; }); })[0];
    }
    function gels(v) {
      if (qtyIndex < 0) return 1;
      var n = parseInt(v.options[qtyIndex], 10);
      return n > 0 ? n : 1;
    }
    /* botón de compra: la barra fija lleva un texto corto para móvil ([data-buy-short]) y el largo ([data-buy-text]) */
    function setBuy(b, ok, label) {
      b.disabled = !ok;
      var t = $('[data-buy-text]', b), sh = $('[data-buy-short]', b);
      if (t) t.textContent = label; else b.textContent = label;
      if (sh) sh.hidden = !ok;
    }
    function text(sel, value, scope) { $$(sel, scope || root).forEach(function (el) { el.textContent = value; }); }
    function show(sel, on, scope) { $$(sel, scope || root).forEach(function (el) { el.hidden = !on; }); }

    function render() {
      var opts = selected(), v = find(opts);
      $$('[data-option-index]', root).forEach(function (g, k) { text('[data-option-label]', opts[k] || '', g); });
      if (v) subSync(v);
      var on = subOn(), pid = subPlanId();
      /* per-gel price on every quantity option, for the flavour in view */
      if (qtyIndex >= 0) {
        $$('[data-option-index="' + qtyIndex + '"] [data-value]', root).forEach(function (b) {
          var o = opts.slice(); o[qtyIndex] = b.getAttribute('data-value');
          var m = find(o), unit = $('[data-qty-unit]', b), off = $('[data-qty-off]', b), subLine = $('[data-qty-sub]', b);
          var ma = sub ? alloc(m, pid) : null;
          b.disabled = !m;
          if (m && unit) unit.textContent = formatMoney(Math.round((on && ma ? ma.price : m.price) / gels(m))) + (labels.perGelShort || '/gel');
          if (subLine) {
            subLine.hidden = !(ma && !on && sub.qtyLine);
            if (ma) subLine.textContent = sub.qtyLine.replace('[unit]', formatMoney(Math.round(ma.price / gels(m))));
          }
          if (off) {
            var has = m && m.compare_at_price > m.price;
            off.hidden = !has;
            if (has) off.textContent = '-' + Math.round((m.compare_at_price - m.price) * 100 / m.compare_at_price) + '%';
          }
        });
      }
      if (!v) {
        $$('[data-buy]').forEach(function (b) { setBuy(b, false, labels.unavailable || 'No disponible'); });
        return;
      }
      if (idInput) idInput.value = v.id;
      if (String(v.id) !== lastId) { lastId = String(v.id); refreshPickup(v.id); }
      var e = eff(v), onSale = e.compare > e.price;
      [root, sticky].forEach(function (scope) {
        if (!scope) return;
        text('[data-price]', formatMoney(e.price), scope);
        text('[data-compare]', onSale ? formatMoney(e.compare) : '', scope);
        show('[data-compare]', onSale, scope);
        text('[data-off]', onSale ? '-' + Math.round((e.compare - e.price) * 100 / e.compare) + '%' : '', scope);
        show('[data-off]', onSale, scope);
        text('[data-unit]', formatMoney(Math.round(e.price / gels(v))) + ' ' + (labels.perGel || 'por gel'), scope);
        show('[data-unit]', qtyIndex >= 0 && gels(v) > 1, scope);
      });
      var stock = $('[data-stock]', root);
      if (stock) {
        stock.classList.toggle('is-out', !v.available);
        text('[data-stock-label]', v.available ? (labels.inStock || 'En stock') : (labels.soldOut || 'Agotado'), stock);
        var byQty = data.shipMin > 0 && qtyIndex >= 0;
        var free = byQty ? gels(v) >= data.shipMin : data.freeShipping > 0 && e.price >= data.freeShipping;
        var note = v.available ? ((byQty ? (free ? labels.freeQty : labels.freeFromQty) : (free ? labels.freeNow : labels.freeFrom)) || '') : '';
        text('[data-stock-note]', note ? '· ' + note : '', stock);
      }
      $$('[data-buy]').forEach(function (b) {
        setBuy(b, v.available, v.available ? (labels.buy || 'Comprar ahora') : (labels.soldOut || 'Agotado'));
      });
      if (sticky) {
        $$('select[data-sticky-option]', sticky).forEach(function (s) { s.value = opts[parseInt(s.getAttribute('data-sticky-option'), 10)]; });
        text('[data-sticky-variant]', v.options.join(' · '), sticky);
        var thumb = $('.pm-sticky__prod img', sticky);
        if (thumb && v.thumb && thumb.getAttribute('src') !== v.thumb) { thumb.removeAttribute('srcset'); thumb.src = v.thumb; }
        var sid = $('input[name="id"]', sticky); if (sid) sid.value = v.id;
        var sp = $('[data-sticky-plan]', sticky), spOpt = $('[data-sub-plan]', root);
        if (sp) {
          sp.hidden = !on;
          var spName = spOpt && spOpt.selectedIndex > -1 ? spOpt.options[spOpt.selectedIndex].text : null;
          if (spName) sp.textContent = (sub.stickyLabel ? sub.stickyLabel + ' · ' : '') + spName;
        }
      }
      /* gallery by flavour: one flavour shows only its own pictures and its athlete; the mix shows everything */
      (function () {
        var g = $('[data-gallery]', root); if (!g) return;
        var label = v.options.join(' ').toLowerCase();
        var key = /mix/.test(label) ? 'mix' : /berr/.test(label) ? 'berries' : /mango|caff/.test(label) ? 'mango' : /tropical/.test(label) ? 'tropical' : 'mix';
        Array.prototype.forEach.call(g.children, function (t) {
          var fk = t.getAttribute('data-fk'); if (!fk) return;
          var athlete = t.hasAttribute('data-athlete');
          /* las fotos comunes de la ficha (uso, beneficios, comparativa, tecnología) se ven con cualquier sabor */
          t.hidden = key === 'mix' ? (athlete && fk !== 'mix') : (fk !== key && !t.hasAttribute('data-common'));
        });
      })();
      /* bring the variant picture to the front of the gallery */
      if (v.featured_media_id) {
        var g = $('[data-gallery]', root), tile = g && $('[data-media-id="' + v.featured_media_id + '"]', g);
        if (tile && g.firstElementChild !== tile) g.insertBefore(tile, g.firstElementChild);
      }
      /* next quantity step for the upgrade row */
      var up = $('[data-upsell]', root);
      if (up && qtyIndex >= 0) {
        var values = data.qtyValues || [], pos = values.indexOf(opts[qtyIndex]), nextV = null;
        if (pos > -1 && pos < values.length - 1) { var o2 = opts.slice(); o2[qtyIndex] = values[pos + 1]; nextV = find(o2); }
        up.hidden = !nextV;
        if (nextV) {
          up.setAttribute('data-upsell-value', values[pos + 1]);
          text('[data-upsell-title]', (labels.upgradeTo || 'Sube a') + ' ' + values[pos + 1], up);
          var ne = eff(nextV);
          var save = ne.compare > ne.price ? ' · ' + (labels.youSave || 'ahorras un') + ' ' + Math.round((ne.compare - ne.price) * 100 / ne.compare) + '%' : '';
          text('[data-upsell-note]', formatMoney(Math.round(ne.price / gels(nextV))) + ' ' + (labels.perGel || 'por gel') + save, up);
        }
      }
      /* el pago rápido (Shop Pay, etc.) compra sin suscripción: se oculta mientras está marcada */
      var dc = $('.pm-dynamic-checkout', root); if (dc) dc.hidden = !!(on && pid);
      var gl = $('[data-guarantee-qty]', root); if (gl && v && qtyIndex >= 0) gl.hidden = parseInt(v.options[qtyIndex], 10) !== parseInt(gl.getAttribute('data-guarantee-qty'), 10);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        if (subBox) { if (on && pid) url.searchParams.set('selling_plan', pid); else url.searchParams.delete('selling_plan'); }
        window.history.replaceState({}, '', url.toString());
      }
      /* aviso para otras secciones (perfil sensorial, etc.) */
      var detail = { variant: v, options: opts, flavor: data.flavorIndex >= 0 ? opts[data.flavorIndex] : null, sellingPlan: on ? pid : null };
      window.PM = window.PM || {}; window.PM.variant = detail;
      document.dispatchEvent(new CustomEvent('pm:variant', { detail: detail }));
    }
    /* store pickup line for the chosen variant (Section Rendering API) */
    var pickupTimer = null;
    function refreshPickup(id) {
      var box = $('[data-pickup]', root), sid = root.getAttribute('data-section');
      if (!box || !sid || !window.fetch) return;
      clearTimeout(pickupTimer);
      pickupTimer = setTimeout(function () {
        fetch(window.location.pathname + '?variant=' + id + '&section_id=' + encodeURIComponent(sid))
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) return;
            var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pickup]');
            if (fresh) box.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      }, 250);
    }
    function pick(index, value) {
      var g = $('[data-option-index="' + index + '"]', root);
      if (!g) return;
      $$('[data-value]', g).forEach(function (b) {
        var on = b.getAttribute('data-value') === value;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-selected', on);
      });
      render();
    }
    /* elegir una variante completa (FitGuide y enlaces ?variant= a esta misma ficha) */
    function selectVariant(id) {
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return false;
      v.options.forEach(function (val, k) {
        var g = $('[data-option-index="' + k + '"]', root);
        if (!g) return;
        $$('[data-value]', g).forEach(function (b) {
          var on = b.getAttribute('data-value') === val;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.classList.toggle('is-selected', on);
        });
      });
      render();
      return true;
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-pick-variant]');
      if (!a || root.contains(a)) return;
      if (selectVariant(a.getAttribute('data-pick-variant'))) {
        e.preventDefault();
        var top = root.getBoundingClientRect().top + window.pageYOffset - 140;
        window.scrollTo({ top: Math.max(0, top), behavior: reduceMotionPick ? 'auto' : 'smooth' });
        var focusEl = $('[data-option-index] [aria-pressed="true"]', root);
        if (focusEl) setTimeout(function () { focusEl.focus({ preventScroll: true }); }, reduceMotionPick ? 0 : 500);
      }
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-option-index] [data-value]');
      if (b && root.contains(b)) { e.preventDefault(); pick(b.closest('[data-option-index]').getAttribute('data-option-index'), b.getAttribute('data-value')); return; }
      var u = e.target.closest('[data-upsell-apply]');
      if (u) { e.preventDefault(); pick(qtyIndex, u.closest('[data-upsell]').getAttribute('data-upsell-value')); }
    });
    if (subBox) {
      subBox.addEventListener('change', function (e) {
        if (e.target.matches('[data-sub-plan]')) {
          var r = $('[data-sub-radio="sub"]', subBox);
          if (r) { r.value = e.target.value; r.checked = true; }
        }
        render();
      });
    }
    /* enlaces "Suscríbete" de otras secciones: marcan la suscripción y suben a la caja */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-sub-pick]');
      var r = subBox && $('[data-sub-radio="sub"]', subBox);
      if (!a || !r || r.disabled) return;
      e.preventDefault();
      r.checked = true;
      render();
      var top = subBox.getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotionPick ? 'auto' : 'smooth' });
    });
    if (sticky) {
      /* el precio de la barra fija sube a elegir sabor y cantidad */
      var pickBtn = $('[data-sticky-pick]', sticky);
      if (pickBtn) pickBtn.addEventListener('click', function () {
        var target = $('[data-option-index]', root) || root;
        var top = target.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: Math.max(0, top), behavior: reduceMotionPick ? 'auto' : 'smooth' });
        var focusEl = $('[data-option-index] [aria-pressed="true"]', root);
        if (focusEl) setTimeout(function () { focusEl.focus({ preventScroll: true }); }, reduceMotionPick ? 0 : 500);
      });
      $$('select[data-sticky-option]', sticky).forEach(function (s) {
        s.addEventListener('change', function () { pick(s.getAttribute('data-sticky-option'), s.value); });
      });
      /* altura real de la cabecera fija: la barra de compra en móvil va justo debajo */
      var hdr = document.querySelector('.pm-section-header') || document.querySelector('.pm-header');
      var setH = function () { if (hdr) document.documentElement.style.setProperty('--pm-header-h', hdr.getBoundingClientRect().height + 'px'); };
      setH(); window.addEventListener('resize', setH);
      if ('IntersectionObserver' in window && buy) {
        new IntersectionObserver(function (entries) {
          var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', out);
          document.body.classList.toggle('has-sticky', out);
        }).observe(buy);
      }
    }
    render();
  });

  /* ---- buy box: sticky que no corta la caja cuando es más alta que la pantalla ---- */
  $$('.pm-buybox').forEach(function (box) {
    if (!once(box, 'stickytop')) return;
    var mq = window.matchMedia('(min-width: 990px)');
    function fit() {
      if (!mq.matches) { box.style.removeProperty('--pm-buybox-top'); return; }
      var top = 153, room = window.innerHeight - top - 24, h = box.offsetHeight;
      box.style.setProperty('--pm-buybox-top', (h > room ? Math.round(window.innerHeight - h - 24) : top) + 'px');
    }
    fit();
    window.addEventListener('resize', fit);
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(box);
  });

  /* ---- animación de entrada al hacer scroll ---- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  var revealIO = null;
  if (!reduceMotion && !designMode && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('pm-reveal-on');
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        revealIO.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  }
  /* Dentro de un carrusel horizontal no se anima: las tarjetas fuera de pantalla no entrarían nunca en el observador
     y el desplazamiento vertical haría que el carrusel atrape el scroll de la página en móvil. */
  function inHScroller(el) {
    var p = el.parentElement;
    if (!p) return false;
    var ox = window.getComputedStyle(p).overflowX;
    return (ox === 'auto' || ox === 'scroll') && p.scrollWidth > p.clientWidth + 1;
  }
  $$('[data-reveal]').forEach(function (el) {
    if (!once(el, 'reveal')) return;
    if (revealIO && !inHScroller(el)) revealIO.observe(el); else el.classList.add('is-in');
  });

  /* ---- ficha: perfil sensorial que sigue al sabor elegido ---- */
  $$('[data-specs]').forEach(function (specs) {
    if (!once(specs, 'specs')) return;
    var wrap = $('[data-sensory-wrap]', specs);
    function apply(flavor) {
      if (!flavor) return;
      $$('[data-specs-flavor]', specs).forEach(function (el) { el.textContent = flavor; });
      if (!wrap) return;
      var any = false;
      $$('[data-sensory-flavor]', wrap).forEach(function (b) {
        var on = b.getAttribute('data-sensory-flavor') === flavor;
        b.hidden = !on;
        if (on) {
          any = true;
          if (b.classList.contains('is-in') && revealIO) {
            /* vuelve a llenar las barras al cambiar de sabor */
            b.classList.remove('is-in'); void b.offsetWidth; b.classList.add('is-in');
          } else if (!revealIO) {
            b.classList.add('is-in');
          }
        }
      });
      wrap.hidden = !any;
    }
    document.addEventListener('pm:variant', function (e) { apply(e.detail && e.detail.flavor); });
    if (window.PM && window.PM.variant) apply(window.PM.variant.flavor);
  });

  /* ---- caja de compra: ingredientes por sabor (pestañas sincronizadas con el sabor elegido) ---- */
  $$('[data-ingr]').forEach(function (box) {
    if (!once(box, 'ingr')) return;
    function show(flavor) {
      var panels = $$('[data-ingr-panel]', box), hit = panels.filter(function (p) { return p.getAttribute('data-ingr-panel') === flavor; })[0];
      if (!hit) return;
      panels.forEach(function (p) { p.classList.toggle('is-active', p === hit); });
      $$('[data-ingr-tab]', box).forEach(function (b) {
        var on = b.getAttribute('data-ingr-tab') === flavor;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-selected', on);
      });
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ingr-tab]');
      if (b) { e.preventDefault(); show(b.getAttribute('data-ingr-tab')); }
    });
    document.addEventListener('pm:variant', function (e) { if (e.detail && e.detail.flavor) show(e.detail.flavor); });
  });

  /* ---- caja de compra: información en pestañas (snippets/pdp-info-tabs.liquid) ----
     Flechas, Inicio y Fin mueven entre pestañas. En móvil cada panel se recorta y "Ver todo" lo abre ahí mismo. */
  $$('[data-tabs]').forEach(function (box) {
    if (!once(box, 'tabs')) return;
    var tabs = $$('[role="tab"]', box);
    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    function panelOf(tab) { return document.getElementById(tab.getAttribute('aria-controls')); }
    function fit(panel) {
      var clip = panel && $('[data-tabs-clip]', panel), more = panel && $('[data-tabs-more]', panel);
      if (!clip || !more) return;
      if (panel.classList.contains('is-open')) { more.hidden = false; return; }
      var fits = clip.scrollHeight <= clip.clientHeight + 4;
      more.hidden = fits;
      clip.classList.toggle('is-fits', fits);
    }
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab, p = panelOf(t);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (p) p.hidden = !on;
      });
      if (focus) { tab.focus(); if (tab.scrollIntoView) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
      fit(panelOf(tab));
    }
    box.addEventListener('click', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (t && box.contains(t)) { select(t); return; }
      var more = e.target.closest('[data-tabs-more]');
      if (!more) return;
      var panel = more.closest('[role="tabpanel"]'), open = !panel.classList.contains('is-open');
      panel.classList.toggle('is-open', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = box.getAttribute(open ? 'data-less' : 'data-more') || more.textContent;
      if (!open) { var top = box.getBoundingClientRect().top; if (top < 0) window.scrollBy(0, top - 140); }
    });
    box.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(e.target), next = -1;
      if (i < 0) return;
      if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      if (next < 0) return;
      e.preventDefault();
      select(tabs[next], true);
    });
    box.__pmSelect = function (el) {
      var panel = el.closest('[role="tabpanel"]'), tab = panel && $('[aria-controls="' + panel.id + '"]', box);
      if (!tab) return;
      select(tab);
      panel.classList.add('is-open');
      var more = $('[data-tabs-more]', panel);
      if (more) { more.setAttribute('aria-expanded', 'true'); more.textContent = box.getAttribute('data-less') || more.textContent; }
    };
    var current = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    if (current) select(current);
    if (mq) {
      var refit = function () { $$('[role="tabpanel"]:not([hidden])', box).forEach(fit); };
      if (mq.addEventListener) mq.addEventListener('change', refit); else if (mq.addListener) mq.addListener(refit);
    }
    document.addEventListener('pm:variant', function () { $$('[role="tabpanel"]:not([hidden])', box).forEach(fit); });
    box.addEventListener('click', function (e) { if (e.target.closest('[data-ingr-tab]')) setTimeout(function () { $$('[role="tabpanel"]:not([hidden])', box).forEach(fit); }, 0); });
  });

  /* ---- FAQ: en móvil se ven las primeras y "Ver más preguntas" despliega el resto ---- */
  $$('[data-faq-more]').forEach(function (btn) {
    if (!once(btn, 'faqmore')) return;
    btn.addEventListener('click', function () {
      var list = btn.closest('[data-faq-list]');
      if (!list) return;
      list.classList.add('is-all');
      btn.setAttribute('aria-expanded', 'true');
      btn.hidden = true;
      var first = $('.pm-faq__item--more summary', list);
      if (first) first.focus();
    });
  });

  /* ---- UGC: el vídeo se reproduce solo al pulsar ---- */
  $$('[data-ugc-video]').forEach(function (btn) {
    if (!once(btn, 'ugc')) return;
    btn.addEventListener('click', function () {
      var item = btn.closest('.pm-ugc__item'), video = item && $('video', item);
      if (!video) return;
      item.classList.add('is-playing');
      video.controls = true;
      btn.hidden = true;
      var p = video.play(); if (p && p.catch) p.catch(function () {});
    });
  });

  /* ---- UGC de Instagram o YouTube: el iframe solo se crea al pulsar y se quita al cerrar ---- */
  $$('[data-ugc-embed]').forEach(function (btn) {
    if (!once(btn, 'ugcembed')) return;
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-ugc-embed');
      var section = btn.closest('section'), dlg = section && $('[data-ugc-dialog]', section);
      if (!dlg || typeof dlg.showModal !== 'function') { window.open(src, '_blank', 'noopener'); return; }
      var frame = $('.pm-ugc-dialog__frame', dlg), f = document.createElement('iframe');
      f.src = src; f.title = btn.getAttribute('aria-label') || 'Vídeo';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; f.allowFullscreen = true;
      frame.innerHTML = ''; frame.appendChild(f);
      dlg.__pm_opener = btn; dlg.showModal();
    });
  });
  $$('[data-ugc-dialog]').forEach(function (dlg) {
    if (!once(dlg, 'ugcdialog')) return;
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-ugc-close]')) dlg.close(); });
    dlg.addEventListener('close', function () {
      var frame = $('.pm-ugc-dialog__frame', dlg); if (frame) frame.innerHTML = '';
      if (dlg.__pm_opener) dlg.__pm_opener.focus();
    });
  });

  /* mobile menu: Escape closes it and returns focus to the button */
  $$('.pm-drawer').forEach(function (drawer) {
    if (!once(drawer, 'drawer')) return;
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !drawer.open) return;
      drawer.open = false;
      var s = $('summary', drawer); if (s) s.focus();
    });
  });

  $$('[data-filters-toggle]').forEach(function (btn) {
    if (!once(btn, 'toggle')) return;
    btn.addEventListener('click', function () {
      var panel = $('[data-filters]');
      if (!panel) return;
      var open = panel.classList.toggle('is-toggled');
      if (window.matchMedia('(min-width: 990px)').matches) open = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  $$('[data-filters-form]').forEach(function (form) {
    if (!once(form, 'filters')) return;
    form.addEventListener('change', function () { form.submit(); });
  });
  $$('[data-cart-form]').forEach(function (form) {
    if (!once(form, 'cart')) return;
    form.addEventListener('change', function (e) { if (e.target.matches('input[name="updates[]"]')) form.submit(); });
  });
  }
  boot();
  document.addEventListener('shopify:section:load', boot);

  /* ---- enlace a un acordeón (#nutricion, #ingredientes...): lo abre ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (target && target.tagName === 'DETAILS') target.open = true;
    /* dentro de las pestañas de la caja de compra (#nutricion...): activa la pestaña y la abre entera */
    var tabsBox = target && target.closest && target.closest('[data-tabs]');
    if (tabsBox && tabsBox.__pmSelect) tabsBox.__pmSelect(target);
  });
  /* editor de temas: al elegir un bloque de pestaña, se muestra */
  document.addEventListener('shopify:block:select', function (e) {
    var tabsBox = e.target && e.target.closest && e.target.closest('[data-tabs]');
    if (tabsBox && tabsBox.__pmSelect) tabsBox.__pmSelect(e.target);
  });

  /* ---- carrito (página): eliminar línea con /cart/change.js y repintar la sección (Section Rendering API) ---- */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm || !window.fetch) return;
    e.preventDefault();
    var id = rm.getAttribute('data-section');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var page = rm.closest('[data-cart-page]');
    if (page) page.style.opacity = '.5';
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +rm.getAttribute('data-cart-remove'), quantity: 0, sections: id ? [id] : [] })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (cart) {
        $$('.pm-cart__count').forEach(function (el) { el.textContent = cart.item_count; });
        var html = cart.sections && cart.sections[id];
        var wrap = document.getElementById('shopify-section-' + id);
        if (!html || !wrap) { window.location.reload(); return; }
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('#shopify-section-' + id) || tmp.firstElementChild;
        wrap.innerHTML = fresh ? fresh.innerHTML : html;
        boot();
      })
      .catch(function () { window.location.href = rm.href; });
  });

  /* ---- carrito como gel: se llena hasta el envío gratis ----
     Cualquier script que cambie el carrito actualiza .pm-cart__count; al cambiar, se pide /cart.js y se rellena el gel. */
  (function () {
    var gels = $$('[data-cart-gel]');
    var counts = $$('.pm-cart__count');
    if (!gels.length || !counts.length || !window.fetch || !window.MutationObserver) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var timer;
    function level(total, threshold) {
      if (!threshold || !total) return 0;
      return Math.max(12, Math.min(100, Math.round(total * 100 / threshold)));
    }
    function refresh() {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          gels.forEach(function (g) {
            var before = +g.style.getPropertyValue('--gel') || 0;
            var now = level(cart.total_price, +g.getAttribute('data-threshold'));
            g.style.setProperty('--gel', now);
            if (now > before) { g.classList.remove('is-fill'); void g.getBoundingClientRect(); g.classList.add('is-fill'); }
          });
        })
        .catch(function () {});
    }
    var mo = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(refresh, 150); });
    counts.forEach(function (c) { mo.observe(c, { childList: true, characterData: true, subtree: true }); });
    gels.forEach(function (g) { g.addEventListener('animationend', function (e) { if (e.animationName === 'pm-gel-sway') g.classList.remove('is-fill'); }); });
  })();

  /* ---- quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]');
    if (!b) return;
    var input = $('input', b.closest('.pm-stepper'));
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + parseInt(b.getAttribute('data-step'), 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

})();

/* Ficha: la explicación de cafeína bajo el sabor cambia con el sabor elegido */
document.addEventListener('pm:variant', function (e) {
  var f = ((e.detail && e.detail.flavor) || '').toLowerCase();
  document.querySelectorAll('[data-caff-hint]').forEach(function (p) {
    var t = p.getAttribute(f.indexOf('mix') > -1 ? 'data-mix' : (f.indexOf('caff') > -1 || f.indexOf('mango') > -1 ? 'data-yes' : 'data-none'));
    var span = p.querySelector('span'); if (span && t) span.textContent = t;
  });
});

/* Ficha en ordenador: la columna de compra baja con la página y, al llegar a su final, se queda fija mientras siguen las fotos */
(function () {
  function fit() {
    var b = document.querySelector('.pm-pdp > .pm-buybox'); if (!b) return;
    var top = Math.min(110, window.innerHeight - b.offsetHeight - 20);
    b.style.setProperty('--pm-buy-top', top + 'px');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
  document.addEventListener('pm:variant', function () { setTimeout(fit, 50); });
})();

